module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "m-related-news"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.relatedNews), function(item) {
    return _c('news-item', {
      key: item.id,
      attrs: {
        "item": item
      }
    })
  })], 2) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "m-bt"
  }, [_c('span', {
    staticClass: "u-tt"
  }, [_vm._v("推荐阅读")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b088e98!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/news-related.vue
// module id = 848
// module chunks = 2